<div class="lightbox-root">
    <button class="lightbox-close-btn" type="button" (click)="close()" aria-label="Close">
        <mat-icon>close</mat-icon>
    </button>

    @if (photos.length > 1) {
        <button
                class="lightbox-nav-btn lightbox-nav-prev"
                type="button"
                (click)="prev()"
                [disabled]="!hasPrev()"
                aria-label="Previous photo">
            <mat-icon>chevron_left</mat-icon>
        </button>

        <button
                class="lightbox-nav-btn lightbox-nav-next"
                type="button"
                (click)="next()"
                [disabled]="!hasNext()"
                aria-label="Next photo">
            <mat-icon>chevron_right</mat-icon>
        </button>
    }

    <div
            class="lightbox-image-container"
            (wheel)="onWheel($event)"
            (pointerdown)="onPointerDown($event)"
            (pointermove)="onPointerMove($event)"
            (pointerup)="onPointerUp($event)"
            (pointercancel)="onPointerUp($event)">
        <img
                class="lightbox-image"
                [src]="currentPhoto()"
                [style.transform]="transform()"
                draggable="false"
                alt=""/>
    </div>

    @if (photos.length > 1) {
        <div class="lightbox-counter">
            {{ currentIndex() + 1 }} / {{ photos.length }}
        </div>
    }
</div>
